import {
  useSetting,
  useAssignSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250715 } from "@faire/web-api--source/indigofair/settings/IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250715";

// This setting is used for both pre and post FCO. The pre FCO setting is no longer used.
// Analysis for the two audiences will be done in offline.
export const useSettingCartBuildingAndSavingsGuide = (): boolean =>
  useSetting(IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250715, false);

export const useAssignSettingCartBuildingAndSavingsGuide = () =>
  useAssignSetting(IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250715);
